import React, { useState, useCallback } from 'react';
import './OtherListing.css';
import '../createPostLayout.css';
import VerticalAd from '../../VerticalBanner';
import { uploadToS3 } from "../../../Utils/Utils.js"
import { apiUrl, jsonAuthHeaders } from "../../../config/api.js"
import { devLog } from "../../../config/devLog.js"
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import VerifyCompanyModal from '../../../components/SignUpScreen/verifyModal/VerifyModal.js';


const OtherListingForm = () => {
  const navigate = useNavigate()
  const { userId, userDetails } = useSelector((state) => state.userReducer);
  
  const [formData, setFormData] = useState({
    title: '',
    listingCategory: '',
    keyDate: '',
    details: '',
    additionalInformation: '',
    images: []
  });

  const [errors, setErrors] = useState({});
  const [imagePreviews, setImagePreviews] = useState([]);
  const [showVerifyModal,setShowVerifyModal] = useState(false)
  const [adsRailFilled, setAdsRailFilled] = useState(false);

  const handleVerticalAdSlotState = useCallback((status) => {
    setAdsRailFilled(status === "filled");
  }, []);

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === 'images') {
      const selectedFiles = Array.from(files);
      setFormData({ ...formData, images: selectedFiles });

      const previewUrls = selectedFiles.map(file => URL.createObjectURL(file));
      setImagePreviews(previewUrls);
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.title) newErrors.title = 'Title is required';
    if (!formData.listingCategory) newErrors.listingCategory = 'Category is required';
    if (!formData.keyDate) newErrors.keyDate = 'Date is required';
    if (!formData.details) newErrors.details = 'Details are required';
    // if (!formData.additionalInformation) newErrors.additionalInformation = 'Additional info is required';
    // if (formData.images.length === 0) newErrors.images = 'At least one image is required';
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validate()) {
      let imagesUrls = []
      if(formData.images.length > 0){
        imagesUrls = await uploadToS3(formData.images)
      }
      devLog("[otherListing] submit", { hasImages: !!formData?.images?.length })
      const toastId = toast.loading("Creating your Listing...",{position: "bottom-center"});
            const response = await fetch(apiUrl("createOtherListing"), {
                    method: 'POST',
                    headers: jsonAuthHeaders(),
              body: JSON.stringify({ categoryId:3, createdBy: userId, ...formData, pictures:imagesUrls.join(",")}),
            });
      
            const data = await response.json();
            if (response.ok) {
                  toast.update(toastId, {
                    render: "Listing Created successfully 🎉",
                    type: "success",
                    isLoading: false,
                    autoClose: 3000,
                    closeOnClick: true
                  });
                } else {
                  toast.update(toastId, {
                    render: data.message || "Something went wrong 😕",
                    type: "error",
                    isLoading: false,
                    autoClose: 3000,
                    closeOnClick: true
                  });
                }
                  setTimeout(() => {
                                  navigate("/home")
                                }, 3000);
    }
  };

  return (
    <div className="otherListing">
                         {showVerifyModal&& <VerifyCompanyModal isOpen={showVerifyModal} onClose={()=>{setShowVerifyModal(false)}} message={"You cannot proceed further with verifying yourself as corporate NRI, Please verify your corporate mail ID."}/>}
      {!adsRailFilled && (
        <div className="create-post-ad-probe" aria-hidden>
          <VerticalAd onSlotStateChange={handleVerticalAdSlotState} />
        </div>
      )}
      <div
        className={`create-post-layout ${adsRailFilled ? 'create-post-layout--with-ad' : ''}`}
      >
        <div className="create-post-main">
      <div className="other-header">
        <h3>Other Listing</h3>
      </div>
      
      <form className="listing-form" onSubmit={(e)=>{
        if(!userDetails.is_verified){ setShowVerifyModal(true)}
        else{
          handleSubmit(e)
          }
          }}>

      <label>Title</label>
      <input
        type="text"
        name="title"
        value={formData.title}
        onChange={handleChange}
        className={errors.title ? 'error-border' : ''}
        placeholder="Enter title"
      />
      {errors.title && <p className="error">{errors.title}</p>}

    <div style={{display:"flex", gap:"10px"}}>
      <div style={{width:"100%"}}><label>Category</label>
      <select
        name="listingCategory"
        value={formData.listingCategory}
        onChange={handleChange}
        className={errors.listingCategory ? 'error-border' : ''}
      >
        <option value="">Select Category</option>
        <option value="Travel">Travel Companion</option>
        <option value="Cars">Cars</option>
        <option value="medical">Medical Support</option>
        <option value="community">Community</option>
        <option value="vouchers">Vouchers or Offers</option>
        <option value="Others">Others</option>
      </select>
      {errors.listingCategory && <p className="error">{errors.listingCategory}</p>}
      </div>

      <div style={{width:"100%"}}>
      <label>Key Date</label>
      <input
        type="date"
        name="keyDate"
        value={formData.keyDate}
        onChange={handleChange}
        className={errors.keyDate ? 'error-border' : ''}
      />
      {errors.keyDate && <p className="error">{errors.keyDate}</p>}
      </div>
      </div>
      <label>Details</label>
      <textarea
        name="details"
        value={formData.details}
        onChange={handleChange}
        placeholder="Enter Details"
        className={errors.details ? 'error-border' : ''}
      />
      {errors.details && <p className="error">{errors.details}</p>}

      <label>Additional Information</label>
      <textarea
        name="additionalInformation"
        value={formData.additionalInformation}
        onChange={handleChange}
        placeholder="Enter additional information"
        className={errors.additionalInformation ? 'error-border' : ''}
      />
      {errors.additionalInformation && <p className="error">{errors.additionalInformation}</p>}

      <label>Upload Pictures:</label>
      <input
        type="file"
        name="images"
        multiple
        onChange={handleChange}
        className={errors.images ? 'error-border' : ''}
      />
      {errors.images && <p className="error">{errors.images}</p>}

      {imagePreviews.length > 0 && (
        <div className="image-preview-container">
          {imagePreviews.map((url, idx) => (
            <img src={url} alt={`preview-${idx}`} key={idx} className="preview-img" />
          ))}
        </div>
      )}

      <button type="submit" style={{ margin:"auto", width:"100%", maxWidth:"250px",cursor:"pointer"}}>Submit</button>
    </form>
        </div>
        {adsRailFilled && (
          <aside className="create-post-ads" aria-label="Advertisement">
            <div className="create-post-ads-inner">
              <span className="create-post-ads-label">Advertisement</span>
              <VerticalAd onSlotStateChange={handleVerticalAdSlotState} />
            </div>
          </aside>
        )}
      </div>
    </div>
  );
};

export default OtherListingForm;
